import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import classNames from 'classnames';
import style from './ModalSentErrorWithInfoForComboGroup.module.scss';

interface IProps {
	onConsentEvent: () => void;
	data: {
		translationKey: string;
		names: string[];
	} | null;
}

const ModalSentErrorWithInfoForComboGroup: React.FC<IProps> = ({ onConsentEvent, data }) => {
	const containerClasses = classNames(style.container, { [style.visible]: data });

	const getAdditionalInfo = () => {
		return (
			<>
				<Text
					className={style.nameWrapper}
					translationNameSpace="modals"
					translationKey={data?.translationKey}
					size="xxl"
					weight="bold"
					align="center"
				/>
				<div className={style.additionalInfoItems}>
					{data?.names.map((itemName, i) => (
						<div key={itemName + String(i)} className={style.item}>
							<div className={style.dot} />
							<Text translationKey={itemName} withTooltip={true} />
						</div>
					))}
				</div>
			</>
		);
	};

	return (
		<div className={containerClasses}>
			<div className={style.wrapper}>
				<div className={style.closeIconWrapper} onClick={onConsentEvent}>
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				</div>
				<svg className={style.errorIcon}>
					<use xlinkHref={`${breadcrumbs}#error`} />
				</svg>
				<div className={style.description}>{getAdditionalInfo()}</div>
				<div className={style.btnWrapper}>
					<Button
						className={style.okBtn}
						theme="primaryBlue"
						onClick={onConsentEvent}
						type="submit"
						data-test="okButton">
						<Text translationNameSpace="modals" translationKey="okButton" asFragment={true} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default React.memo(ModalSentErrorWithInfoForComboGroup);
